import { useFundFamilyEventRetrieveSuspense } from "gen/endpoints/fund-family-event/fund-family-event";
import { Outlet } from "react-router-dom";
import { FullScreenLoadingState } from "shared/components/empty/FullScreenLoadingState";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const CapitalEventPageWrapper: React.FC = () => {
  const { fundFamilyId, fundFamilyEventId } = useRequiredStringParams();
  const { data: capitalActivityData } = useFundFamilyEventRetrieveSuspense(
    fundFamilyId,
    fundFamilyEventId,
    {
      query: {
        refetchInterval: 1000,
      },
    },
  );

  return (
    <>
      {capitalActivityData.event_workflow_status.is_running && (
        <FullScreenLoadingState
          message={capitalActivityData.event_workflow_status.message}
        />
      )}
      <Outlet />
    </>
  );
};
